export const GET_FLOWS = "GET_FLOWS";
export const CREATE_FLOW = "CREATE_FLOW";
export const UPDATE_FLOW = "UPDATE_FLOW";
export const DELETE_FLOW = "DELETE_FLOW";
export const PUBLISH_FLOW = "PUBLISH_FLOW";
export const DEPRECATE_FLOW = "DEPRECATE_FLOW";
export const GENERATE_PREVIEW = "GENERATE_PREVIEW";
export const UPDATE_CURRENT_FLOW = "UPDATE_CURRENT_FLOW";
export const LOADING_FLOWS = "LOADING_FLOWS";
